module.exports = __webpack_public_path__ + "img/39.c85672a1.svg";